import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { IconButton } from './IconButton';

export function BulkActions({
  count,
  onClear,
  children,
}: {
  count: number;
  onClear: () => void;
  children: ReactNode;
}) {
  if (count < 1) return null;
  return (
    <div
      data-slot="bulk-actions"
      role="group"
      aria-label="Действия с выбранными строками"
      className="flex flex-wrap items-center gap-3 rounded-md border border-brand-fg/20 bg-selected px-3 py-2"
    >
      <span className="mr-auto text-xs font-medium text-fg" aria-live="polite">
        Выбрано: {count}
      </span>
      {children}
      <IconButton variant="ghost" size="sm" aria-label="Снять выбор строк" onClick={onClear}>
        <X />
      </IconButton>
    </div>
  );
}
